import { attr, css, FASTElement, html } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { display } from '../../foundation/display';
import { getToken } from '../../design-tokens';

export interface ISurfaceAnatomy {
    variant: string;
    color: string;
}

// TODO: Component under construction.

/**
 * @element natgen-surface
 */
export class NatGenSurface extends FASTElement implements ISurfaceAnatomy {
    @attr
    color: string = 'neutral';

    get colorToken(): string {
        return getToken(`ui-surface-${this.variant}-color-${this.color}-background-rest`).createCSS();
    }

    @attr
    variant: string = 'filled';
}

export const natGenSurfaceDefinition = NatGenSurface.compose({
    name: `${NatGenDesignSystem.prefix}-surface`,
    template: html<NatGenSurface>`
        <template>
            <!-- <span>${x => x.colorToken}</span> -->
            <slot></slot>
        </template>
    `,
    styles: css<NatGenSurface>`
        ${display('block')}

        :host {
            --elevation: ${getToken('ui-surface-space-elevation')};
            border-radius: calc(${getToken('ui-surface-space-corner-radius')} * 1px);
            background-color: ${x => x.colorToken};
        }
    `
});
